import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userPutRol } from "../../store/auth/actions";
export var useUserPutRole = function (trigger, bodyRequest) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responseUserPutRol: (_a = state.Login.responseUserPutRol) === null || _a === void 0 ? void 0 : _a.data,
            errorUserPutRol: state.Login.errorUserPutRol,
            loadingUserPutRol: state.Login.loadingUserPutRol,
        });
    }), responseUserPutRol = _a.responseUserPutRol, errorUserPutRol = _a.errorUserPutRol, loadingUserPutRol = _a.loadingUserPutRol;
    useEffect(function () {
        if (trigger) {
            dispatch(userPutRol(bodyRequest));
        }
    }, [bodyRequest, trigger]);
    return {
        responseUserPutRol: responseUserPutRol,
        errorUserPutRol: errorUserPutRol,
        loadingUserPutRol: loadingUserPutRol,
    };
};
